import withMatcher from '#/utils/withMatcher';
import {
  IArtistAlbums,
  ITrack,
  TSelectedAlbumType,
} from '../reducers/artistAlbums';

export const createActionArtistAlbumsAddDetails = withMatcher(
  (payload: Omit<IArtistAlbums, 'layout'>) => {
    return {
      type: 'artist_albums/add_details',
      payload,
    };
  }
);

export const createActionArtistAlbumsStartLoading = withMatcher(() => {
  return {
    type: 'artist_albums/start_loading',
  };
});

export const createActionArtistAlbumsStopLoading = withMatcher(() => {
  return {
    type: 'artist_albums/stop_loading',
  };
});

export const createActionArtistAlbumsSetErrorDetails = withMatcher(
  (error: boolean) => {
    return {
      type: 'artist_albums/set_error_details',
      payload: error,
    };
  }
);

export const createActionArtistAlbumsSetSelectedAlbumType = withMatcher(
  (albumType: TSelectedAlbumType) => {
    return {
      type: 'artist_albums/set_selected_album_type',
      payload: albumType,
    };
  }
);

export const createActionArtistAlbumsSetLayout = withMatcher(
  (layout: 'detailed' | 'grid') => {
    return {
      type: 'artist_albums/set_layout',
      payload: layout,
    };
  }
);

export const createActionArtistAlbumsSetIsFollowed = withMatcher(
  (payload: { album: string; follow: boolean }) => {
    return {
      type: 'artist_albums/set_album_is_followed',
      payload,
    };
  }
);

export const createActionArtistAlbumsSetTrackIsFollowed = withMatcher(
  (payload: { album: string; track: string; follow: boolean }) => {
    return {
      type: 'artist_albums/set_album_track_is_followed',
      payload,
    };
  }
);

export const createActionArtistAlbumsSetTracks = withMatcher(
  (payload: { album: string; tracks: ITrack }) => {
    return {
      type: 'artist_albums/set_album_tracks',
      payload,
    };
  }
);

export const createActionArtistAlbumsReset = withMatcher(() => {
  return {
    type: 'artist_albums/reset',
  };
});
